export function getVolunteerMissionStatus(missionStatus) {
    switch (missionStatus) {
        case 'mobilizing':
        case 'inProgress':
        case 'complete':
            return 'active';
        default:
            return 'closed';
    }
}
export function getMissionStatusLabel(t, missionStatus, isAdmin) {
    if (isAdmin) {
        return t(`missions.status.${missionStatus}`);
    }
    const missionStatusVolunteer = getVolunteerMissionStatus(missionStatus);
    return t(`missions.statusVolunteer.${missionStatusVolunteer}`);
}
